import { createAction } from 'redux-actions';

export const setIsClientAccessManagerSelectorOpen = createAction(
  'SET_IS_CLIENT_ACCESS_MANAGER_SELECTOR_OPEN'
);
export const setClientAccessManagerAction = createAction('SET_CLIENT_ACCESS_MANAGER_ACTION');
export const setClientAccessManagerContacts = createAction('SET_CLIENT_ACCESS_MANAGER_CONTACTS');
export const setClientAccessManagerSearchText = createAction(
  'SET_CLIENT_ACCESS_MANAGER_SEARCH_TEXT'
);
